import axios from './my-axios'

export default {
  async getUsers({ commit, state }, query) {
    const { data, headers } = await axios.get(`/v1/accounts/${state.accountId}/users?query=${query}`);
    return data;
  },

  async enableEncryption({ commit, state }, masterPassword) {
    const { data, headers } = await axios.post(`/v1/accounts/${state.accountId}/encryption`, { masterPassword });
    return data;
  },

  async saveReservations({ commit, state }, res) {
    const { data } = await axios.post(`/v1/accounts/${state.accountId}/reservations`, res);

    return data;
  },

  async saveSmtp({ commit, state }, res) {
    const { data } = await axios.post(`/v1/accounts/${state.accountId}/smtp`, res);

    return data;
  },

  async attachGoogleAccount({ commit, state }, authorizationCode) {
    const { data } = await axios.post(`/v1/accounts/${state.accountId}/attach-google-account`, { authorizationCode });

    state.accountSettings.googleAnalytics = state.accountSettings.googleAnalytics || {};
    state.accountSettings.googleAnalytics.profiles = data;

    return data;
  },

  async dettachGoogleAccount({ commit, state }) {
    const { data } = await axios.post(`/v1/accounts/${state.accountId}/dettach-google-account`);
    state.accountSettings.googleAnalytics = null;
    return data;
  },

  async createNewOrder({ commit, state }, form) {
    const { data } = form._id ? await axios.put(`/v1/reservations/${form._id}`, form) :  await axios.post(`/v1/reservations`, form);
    return data;
  },

  async getPrivateKey({ commit, state }) {
    const { data } = await axios.get(`/v1/accounts/${state.accountId}/privateKey`);
    return data;
  },

  async getForms({ commit, state }, options = {}) {
    const size = 25;
    try {
      let { data, headers } = await axios.get(`/v1/forms?accountId=${state.accountId}&page=${state.formsPage}&sorting=${state.formsSorting}&size=${size}&q=${state.searchText}`);
      state.totalForms = parseInt(headers[ 'x-total-count' ]) || 0;

      data = data.map(item => {
        item.options.availablePartySize = item.options.availablePartySize || [];
        return item;
      });

      if (options.page === 1) {
        state.forms = data;
      } else {
        state.forms = state.forms.concat(data);
      }
      state.isFormsFullList = state.forms.length === state.totalForms;
    } catch (err) {
      console.log(err);
    }
  },
  async loadUnreadedSubmissions({ commit, state }, isUpdateList) {
    try {
      state.unreadedLoading = true;
      let params = [];
      params.push('accountId=' + state.accountId);
      params.push('page=' + state.unreadedPage);
      params.push('size=' + state.unreadedPageSize);
      //params.push('isReaded=false');

      const { data, headers } = await axios.get(`/v1/submissions?${params.join('&')}`);

      state.unreadedTotal = parseInt(headers[ 'x-total-count' ]);
      state.unreadedLoading = false;
      if (state.unreadedPage === 0) {
        state.unreadedSubmissions = data;
      } else {
        state.unreadedSubmissions = state.unreadedSubmissions.concat(data);
      }
      state.isUnreadedFullList = state.unreadedSubmissions.length === state.unreadedTotal;
    } catch (err) {
      console.log(err);
    }
  },
  async loadUnreadedSubmissionsPage({ dispatch, state }) {
    if (state.unreadedLoading || state.isUnreadedFullList && state.unreadedPage !== 0) {
      return;
    }
    state.unreadedPage++;
    await dispatch('loadUnreadedSubmissions');
  },

  async getFilledForms({ commit, state }, formId) {
    try {
      let params = [];
      params.push('accountId=' + state.accountId);
      params.push('page=' + state.filledFormsPage);
      params.push('size=' + state.filledFormsPageSize);
      for (let filterName in state.filledFormsFilters) {
        params.push(filterName + '=' + state.filledFormsFilters[ filterName ])
      }
      const { data, headers } = await axios.get(`/v1/forms/${formId}/submissions?${params.join('&')}`);
      state.filledForms = data;
      state.filledTotalForms = parseInt(headers[ 'x-total-count' ]);
    } catch (err) {
      console.log(err);
    }
  },
  async getFilledFormFilters({ commit, state }, formId) {
    const { data } = await axios.get(`/v1/forms/${formId}/submission-filters?accountId=${state.accountId}`);
    return data;
  },
  async deleteForm({ dispatch, state }, form) {
    try {
      const { data } = await axios.delete(`/v1/forms/${form._id}`);
      await dispatch('loadForms');
    } catch (err) {
      console.log(err);
    }
  },
  async getAccountSettings({ dispatch, state }) {
    try {
      const { data } = await axios.get(`/v1/accounts/${state.accountId}/settings`);
      data.reservation = data.reservation || {};
      data.reservation.hours = data.reservation.hours || {
        monday: { hours: [{opens: '09:00', closes: '18:00'}], isOpen: true },
        tuesday: { hours: [{opens: '09:00', closes: '18:00'}], isOpen: true },
        wednesday: { hours: [{opens: '09:00', closes: '18:00'}], isOpen: true },
        thursday: { hours: [{opens: '09:00', closes: '18:00'}], isOpen: true },
        friday: { hours: [{opens: '09:00', closes: '18:00'}], isOpen: true },
        saturday: { hours: [], isOpen: false },
        sunday: { hours: [], isOpen: false },
      };
      data.reservation.rooms = data.reservation.rooms || [];
      data.reservation.specialDays = data.reservation.specialDays || [];

      data.smtp = data.smtp || {};

      state.accountSettings = data;
      return data;
    } catch (err) {
      console.log(err);
    }
  },

  //
  async loadForms({ dispatch, state }) {
    this.state.isFormsFullList = false;
    this.state.formsPage = 0;
    this.state.forms = [];
    await dispatch('loadFormsPage');
  },

  async loadFormsPage({ dispatch, state }) {
    if (this.state.formsLoading || this.state.isFormsFullList && this.state.formsPage !== 0) {
      return;
    }
    this.state.formsPage++;
    this.state.formsLoading = true;
    await dispatch('getForms');
    this.state.isFormsFullList = state.forms.length === state.totalForms;
    this.state.formsLoading = false;
  },
}



// WEBPACK FOOTER //
// ./client/store/actions.js